import {
	AfterViewInit,
	Component,
	ComponentRef,
	ElementRef,
	EventEmitter,
	HostBinding,
	HostListener,
	Input,
	OnInit,
	Output,
	Renderer2,
	ViewChild
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Sort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { RouterOutletEvent } from 'dbweb-core';
import { ClipboardService } from 'ngx-clipboard';
import { IRecordViewProcess, IRenderRow } from '../model/model';
import { ServiceService, RefreshDataConfig } from '../service/service.service';
import { ContextMenu } from './contex-menu';
import { Header } from './header';
import { IPoint, nonePoint, noneSelector, Selector } from './selector';
import { TableColumnType } from '../model/model';

@Component({
	selector: 'common-table',
	templateUrl: './table.component.html',
	styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, AfterViewInit, Selector, ContextMenu, Header, RouterOutletEvent {
	@HostBinding('class') hostClass = 'content mat-elevation-z1';
	// ä¼ å¥çæ°æ®ä¸­çæ¾ç¤ºå
	displayColumns: TableColumnType[];
	dataSource: IRenderRow[] = [];

	// è·éæ°æ®è¡çå¤çåè¡¨,åå§å¼ä¸ºç©ºæ°ç»ï¼é²æ­¢åºç°ä¸è½è®¿é®.lengthçéè¯¯
	private _processes: IRecordViewProcess[] = [];
	@Input() set processes(val: IRecordViewProcess[]) {
		if (val.length > 0) {
			if (this.fixEndColumns.length === 0) {
				this.fixEndColumns.push({
					index: -1,
					Name: '_æä½',
					Type: '',
					sticky: false,
					stickyEnd: true,
					showToolbar: false
				});
			}
		} else {
			this.fixEndColumns.splice(0);
		}
		this._processes = val;
	}
	get processes() {
		return this._processes;
	}
	@Output() sortChange = new EventEmitter<Sort>();
	@Output() processClick = new EventEmitter<{ pro: IRecordViewProcess; row: IRenderRow }>();
	_tableColumns: TableColumnType[] = [];
	@ViewChild('tabData', { read: ElementRef, static: true })
	tabData: ElementRef<HTMLTableElement>;
	@ViewChild('tabData', { static: true })
	tabDataOrg: MatTable<IRenderRow>;
	@ViewChild(MatMenuTrigger, { static: true }) contextMenu: MatMenuTrigger;
	// å½ååé¨çåï¼å¯è½æ¯ç¨æ·è°æ´è¿åçé¡ºåº
	columns: TableColumnType[];
	// å¤çæé®æ¯å¦æ¯å±å¼ç
	processExpand = true;

	displayColumnNames: string[] = [];
	// å®æ¶å¨
	timer: NodeJS.Timer;
	leftPressed: boolean;
	x: number;
	y: number;
	readonly fixStartColumns: TableColumnType[] = [
		{ index: 0, Name: '_select', Type: '', sticky: true, stickyEnd: false, showToolbar: false },
		{ index: 1, Name: '_åºå·', Type: 'STR', sticky: true, stickyEnd: false, showToolbar: false }
	];
	readonly fixEndColumns: TableColumnType[] = [];

	contextMenuPosition = { x: '0px', y: '0px' };
	// è¦ç¨å¤å¶çæ¹å¼ï¼å¦åä¼ä¿®æ¹ænonePoint
	current: IPoint = { ...nonePoint };
	// éæ©ç¨å°çå±æ§ãå½æ°
	readonly selector = { ...noneSelector };
	cellSelector = Selector.prototype.cellSelector;
	cellSelectorLeft = Selector.prototype.cellSelectorLeft;
	cellSelectorBottom = Selector.prototype.cellSelectorBottom;
	cellSelectorRight = Selector.prototype.cellSelectorRight;
	cellSelectorTop = Selector.prototype.cellSelectorTop;
	cellMouseDown = Selector.prototype.cellMouseDown;
	cellMouseEnter = Selector.prototype.cellMouseEnter;

	@HostListener('window:mouseup', ['$event'])
	mouseUp = Selector.prototype.mouseUp;
	closeMouseDownListern: () => void;
	onMouseMove = Selector.prototype.onMouseMove.bind(this);
	scrollTable = Selector.prototype.scrollTable;
	openContextMenu = ContextMenu.prototype.openContextMenu;
	onSelCopyClick = ContextMenu.prototype.onSelCopyClick;
	onSelLineMenuClick = ContextMenu.prototype.onSelLineMenuClick;
	onSelCancelLineMenuClick = ContextMenu.prototype.onSelCancelLineMenuClick;
	onSelAllMenuClick = ContextMenu.prototype.onSelAllMenuClick;
	// åå¤´åè½
	headerMouseenter = Header.prototype.headerMouseenter;
	headerMouseleave = Header.prototype.headerMouseleave;
	lockButtonClick = Header.prototype.lockButtonClick;
	stickyColumnRight = Header.prototype.stickyColumnRight;
	syncColumn = Header.prototype.syncColumn;
	unlockButtonClick = Header.prototype.unlockButtonClick;
	toLeftButtonClick = Header.prototype.toLeftButtonClick;
	toRightButtonClick = Header.prototype.toRightButtonClick;

	tableHasScrollbar: boolean;
	headerToolbarShowTimer: NodeJS.Timer;

	private scrollLeft = 0;
	private scrollTop = 0;
	constructor(
		public svr: ServiceService,
		public _clipboardService: ClipboardService,
		public elRef: ElementRef,
		public renderer: Renderer2
	) {}
	//  keepSequenceæ¯å¦ä¿çåçé¡ºåº
	setDataSource(val: IRenderRow[], dispCols: TableColumnType[], keepSequence: boolean) {
		// è¦å¤å¶ï¼ä¸è½èµå¼ï¼å¦åä¼ä¿®æ¹ænoneSelectorçå¼
		Object.assign(this.selector, noneSelector);
		this.dataSource = val;
		this.displayColumns = dispCols;
		if (!keepSequence) {
			// æ¸é¤ä¹åçåé¡ºåºå®ä¹
			this.columns = [];
		}
		// åæ­¥åä¿¡æ¯
		this.syncColumn();
		// ä¸å®è¦å»¶åæ´æ°ï¼å¦åæ²¡æææ
		setTimeout(() => {
			this.updateTableHasScrollbar();
		}, 20);
	}
	ngOnInit() {}
	ngAfterViewInit(): void {
		// ä¸ä½¿ç¨setTimeoutä¼å¼èµ·éè¯¯
		setTimeout(() => {
			this.tableHasScrollbar = this.elRef.nativeElement.scrollWidth > this.elRef.nativeElement.clientWidth;
		}, 100);
	}
	@HostListener('window:resize', ['$event'])
	onResize(event: UIEvent) {
		this.updateTableHasScrollbar();
	}
	private updateTableHasScrollbar() {
		this.tableHasScrollbar = this.elRef.nativeElement.scrollWidth > this.elRef.nativeElement.clientWidth;
	}
	onDetach(): void {
		this.scrollLeft = this.elRef.nativeElement.scrollLeft;
		this.scrollTop = this.elRef.nativeElement.scrollTop;
	}
	onAttach(ref: ComponentRef<any>, activatedRoute: ActivatedRoute): void {
		this.elRef.nativeElement.scrollLeft = this.scrollLeft;
		this.elRef.nativeElement.scrollTop = this.scrollTop;
	}
	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		this.isPageSelected()
			? this.svr.data.tableRowSelection.deselect(...this.dataSource.map(row => row.Key))
			: this.svr.data.tableRowSelection.select(...this.dataSource.map(row => row.Key));
	}
	/** Whether the number of selected elements matches the total number of rows. */
	isPageSelected() {
		return this.dataSource.find(v => !this.svr.data.tableRowSelection.isSelected(v.Key)) === undefined;
	}
	trackByName(i: number, col: TableColumnType) {
		return col.Name;
	}
}
